Pixlee.module('WidgetsApp.Horizontal', function(Horizontal, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    Horizontal.PhotoView = App.Views.ItemView.extend({
        template: require('../common/templates/_photos_item.jst.ejs'),
    });
    Horizontal.PhotoView.include(["PhotoViewHelpers"]);

    Horizontal.HorizontalCollectionView = App.Views.CollectionView.extend({
        childView: Horizontal.PhotoView,
        className: 'transitions-enabled infinite-scroll clearfix',
        emptyView: Horizontal.EmptyView,
        id: 'container'
    });
    Horizontal.HorizontalCollectionView.include(["MasonryCollectionView"]);
});